import RefreshIcon from '@mui/icons-material/Refresh';

import Button from '../../Button';

interface DataTableRefreshProps {
  onRefresh?: () => void;
  isFetching?: boolean;
}

const DataTableRefresh = ({ onRefresh, isFetching }: DataTableRefreshProps) => {
  if (!onRefresh) return null;
  return (
    <Button
      data-testid='refresh-button'
      size='condensed'
      loading={isFetching}
      color='secondary'
      variant='outlined'
      icon={<RefreshIcon />}
      onClick={onRefresh}
    />
  );
};

export default DataTableRefresh;
